import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { findTour } from '../tours';
import { DEMO_TOUR_ID } from './demo-mode';

/**
 * L'entrée d'un onglet de démonstration, `/decouverte/<domaine>/<cas-d-usage>` : mène à l'écran
 * où commence le parcours, que le panneau lance. Hors démonstration, ramène à l'accueil.
 */
@Component({
  selector: 'app-demo-start',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class DemoStart {
  constructor() {
    const tour = findTour(inject(DEMO_TOUR_ID, { optional: true }) ?? '');
    void inject(Router).navigateByUrl(tour?.startUrl ?? '/', { replaceUrl: true });
  }
}
